<template>
  <div class="finishregistration" id="finishregistration">
    
    <NavigationBar>
      <template v-slot:left>
        <img v-if="isSPMUser()" v-on:click="goBack" class="back" src="../assets/icons/ic_16_back.svg">
      </template>
      <template v-slot:center>
        {{ $t('register.finish_registration') }}
      </template>
      <template v-slot:right>
      </template>
    </NavigationBar>

    <div>
      <h1>{{ $t('register.last_step') }}</h1>
      <p>{{ $t('register.finish_registration_text') }}</p>
    </div>

    <form @submit.prevent="isUnder18Changed">

      <div class="input-container">

        <div class="input-checkbox">
          <input v-model="agreedTOS" type="checkbox" id="agreedTOS" name="agreedTOS" />
          <label v-if="userlang === 'de'" for="agreedTOS">{{ $t('create_betgame.agree_terms_of_use_1') }} <a target="_blank" href="/termsofuse">{{ $t('create_betgame.agree_terms_of_use_2') }}</a> {{ $t('create_betgame.agree_terms_of_use_3') }} <a target="_blank" href="/privacy">{{ $t('register.data_protection') }}</a> {{ $t('create_betgame.agree_terms_of_use_4') }}.</label>
          <label v-else for="agreedTOS">{{ $t('create_betgame.agree_terms_of_use_5') }} <a target="_blank" href="/termsofuse">{{ $t('create_betgame.agree_terms_of_use_6') }}</a> {{ $t('create_betgame.agree_terms_of_use_7') }} <a target="_blank" href="/privacy">{{ $t('register.data_protection') }}</a>.</label>
        </div>

        <div class="input-checkbox">
          <input v-model="isUnder18" type="checkbox" id="isUnder18" name="isUnder18" />
          <label for="isUnder18">{{ $t('create_betgame.i_am_under_18') }} ({{ $t('create_betgame.optional') }})</label>
        </div>

      </div>


          <button type="submit" name="button" :disabled="!agreedTOS">
            {{ $t('register.finish_registration') }}
          </button>

    </form>

    <ul class="error-container">
      <li v-for="error in errors">{{ error }}</li>
    </ul>

  </div>
</template>

<script>

import NavigationBar from './../components/NavigationBar'
import { TOAST_DURATION } from '../main'
import Vue from 'vue'
import Numeral from 'numeral'
import moment from 'moment'

export default {
  name: 'finishregistration',
  components: { NavigationBar },
  data () {
    return {
      errors: [],
      isUnder18: false,
      agreedTOS: false
    }
  },
  mounted () {
    this.isUnder18 = this.$store.state.user ? !this.$store.state.user.isadult : false
  },
  computed: {
    userlang () {
      return this.$store.state.language
    }
  },
  methods: {
    goBack () {
      if(this.$store.getters.loggedIn) {
        this.$router.push('/profile')
      } else {
        this.$router.push({ name: 'login' })
      }
    },
    isUnder18Changed () {
      Vue.$log.debug("finishregistration isUnder18Changed")
      this.errors = []
      this.$store.dispatch('patchUser', {acceptedtos: this.agreedTOS, isadult: !this.isUnder18}).then(() => {
        const inco = this.getBGValue('spmic')
        const bid = this.getBGValue('spmbgid')
        if(inco && bid && parseInt(inco) > 0 && parseInt(bid) > 0) {
          this.$router.push('/join/' + bid + '/' + inco)
        } else {
          this.$router.push('/mybetgames') 
        }
      })
    },
    isNullOrUndefined (data) {
      return data === null || data === undefined
    }
  }
}
</script>

<style lang="scss" scoped>
.finishregistration {
  padding: 0 16px 0 16px;
  max-width: 400px;
  margin: 32px auto;

  form {
    padding-top: 16px;
  }

  h1 {
    text-align: center;
  }

  p {
    text-align: center;
    margin-bottom: 26px;
  }

  button {
    margin-top: 16px;
  }
}
</style>
